import { Link } from 'react-router-dom'
import type { Location } from '../../../shared/types/location.js'
import type { CatalogStatus } from '../../../shared/types/models.js'
import StatusBadge from '../../menu/components/StatusBadge.js'

export default function LocationCard({ location, detailTo, editTo }: { location: Location; detailTo: string; editTo?: string }) {
  const address = location.address ?? ''
  return (
    <div className="menu-card menu-card--active">
      <Link to={detailTo} className="menu-card-top-link">
        <div className="menu-card-top">
          <h3 className="menu-card-name">{location.name}</h3>
          <StatusBadge status={location.status as CatalogStatus} />
        </div>
        {location.slug && <span className="menu-card-slug">{location.slug}</span>}
        {address && <p className="menu-card-description">{address}</p>}
      </Link>
      <div className="menu-card-actions">
        <Link to={detailTo} className="btn btn-ghost">Подробнее</Link>
        {editTo && <Link to={editTo} className="btn btn-ghost">Редактировать</Link>}
      </div>
    </div>
  )
}